import React, { useState, useRef, PointerEvent } from 'react';

interface Props {
  src: string;
  className?: string;
  alt?: string;
  pdfMode?: boolean;
}

const DraggableImage: React.FC<Props> = ({ src, className, alt, pdfMode }) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const dragStart = useRef({ x: 0, y: 0 });

  const handlePointerDown = (e: PointerEvent<HTMLImageElement>) => {
    if (pdfMode) return;
    setIsDragging(true);
    dragStart.current = {
      x: e.clientX - position.x,
      y: e.clientY - position.y
    };
    (e.target as HTMLImageElement).setPointerCapture(e.pointerId);
  };

  const handlePointerMove = (e: PointerEvent<HTMLImageElement>) => {
    if (isDragging && !pdfMode) {
      setPosition({
        x: e.clientX - dragStart.current.x,
        y: e.clientY - dragStart.current.y
      });
    }
  };

  const handlePointerUp = (e: PointerEvent<HTMLImageElement>) => {
    if (pdfMode) return;
    setIsDragging(false);
    (e.target as HTMLImageElement).releasePointerCapture(e.pointerId);
  };

  return (
    <img
      src={src}
      className={className}
      alt={alt || ''}
      style={{
        transform: `translate(${position.x}px, ${position.y}px)`,
        cursor: pdfMode ? 'default' : (isDragging ? 'grabbing' : 'grab'),
        touchAction: 'none',
        position: 'relative',
        zIndex: 9999
      }}
      onPointerDown={handlePointerDown}
      onPointerMove={handlePointerMove}
      onPointerUp={handlePointerUp}
      onPointerCancel={handlePointerUp}
      draggable={false}
    />
  );
};

export default DraggableImage;
